/**
 *
 */

import React, { useEffect } from "react";

/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

import "./style.scss";

/* Component starts */
const TenantGroundRule = (props) => {
  /* Props destructuring starts */
  const { data } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  const customOptions = [undefined, null, ""];
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="container-md tenant_rules_wrapper mt-4">
      {!customOptions?.includes(data) ? (
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: data,
          }}
        />
      ) : (
        <p className="font_yellow fw_6 font_xl text_center">Not Added!</p>
      )}
    </div>
  );
};
/* Component ends */

export default TenantGroundRule;
